import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["carrier", "state"];

  filter() {
    const filters = {
      carrier: this.carrierTarget.value,
      state: this.stateTarget.value
    };
    this.stimulate("TerritoryFactorReflex#filter", filters);
  }
}
